import { render, staticRenderFns } from "./uploadStatement.vue?vue&type=template&id=3c0eb710&scoped=true"
import script from "./uploadStatement.vue?vue&type=script&lang=js"
export * from "./uploadStatement.vue?vue&type=script&lang=js"
import style0 from "./uploadStatement.vue?vue&type=style&index=0&id=3c0eb710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0eb710",
  null
  
)

export default component.exports